import { GetFeedback } from '@almbrand/getfeedback';
import { memo, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
	interface Window {
		usabilla: any;
	}
}

export const GetFeedbackComponent: React.FC<any> = memo((props) => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const { usabillaId } = props;
	const location = useLocation();

	useEffect(() => {
		const reloadUsabilla = () => {
			const iframe = document.getElementById('usabilla-e9e9f96ce675');
			if (iframe) {
				// Remove the iframe and reload it
				iframe.remove();
				globalThis.usabilla.load('w.usabilla.com', 'e9e9f96ce675');
			}
		};
		reloadUsabilla();
	}, [location.search]);

	useEffect(() => {
		// After render, check for multiple iframes and remove all except one
		if (wrapperRef.current) {
			const iframes = wrapperRef.current.querySelectorAll('iframe');
			if (iframes.length > 1) {
				// Keep the first iframe, remove the rest
				for (const iframe of Array.from(iframes).slice(1)) {
					iframe.remove();
				}
			}
		}
	});

	return (
		<div ref={wrapperRef}>
			<GetFeedback getFeedbackId={usabillaId} />
		</div>
	);
});

GetFeedbackComponent.displayName = 'GetFeedbackComponent';
